

export default function UserViewSmall() {
	return(
		<div>
		</div>
	);
}